export interface ConnectionLimits {
  storeConnections: number;
  totalIntegrationConnections: number;
  /** Only products with a separate non-store allowance supply this limit. */
  otherIntegrationConnections?: number;
}

export interface ConnectionCounts {
  storeConnections: number;
  otherIntegrationConnections: number;
  totalIntegrationConnections: number;
}

export const resolveConnectionCapacity = (
  counts: ConnectionCounts,
  limits: ConnectionLimits,
  kind: 'store' | 'other',
) => {
  if (counts.totalIntegrationConnections >= limits.totalIntegrationConnections) {
    return { allowed: false, reason: 'total_connection_limit_reached' as const,
      current: counts.totalIntegrationConnections, limit: limits.totalIntegrationConnections };
  }
  if (kind === 'store' && counts.storeConnections >= limits.storeConnections) {
    return { allowed: false, reason: 'store_limit_reached' as const,
      current: counts.storeConnections, limit: limits.storeConnections };
  }
  if (kind === 'other' && limits.otherIntegrationConnections !== undefined
    && counts.otherIntegrationConnections >= limits.otherIntegrationConnections) {
    return { allowed: false, reason: 'integration_group_limit_reached' as const,
      current: counts.otherIntegrationConnections, limit: limits.otherIntegrationConnections };
  }
  return { allowed: true, reason: null,
    current: kind === 'store' ? counts.storeConnections : counts.otherIntegrationConnections,
    limit: kind === 'store' ? limits.storeConnections
      : limits.otherIntegrationConnections ?? limits.totalIntegrationConnections };
};
